import React from 'react'
import sizeType from '../util/sizeStyle'

const Textarea = ({ item, value, validationMessage, handleChange, formData }) => {
  const disabled = typeof item.disabled === 'function' ? item.disabled(formData) : item.disabled || false
  // Return Textarea in view
  return (
    <textarea
      name={item.name}
      placeholder={item.placeholder}
      disabled={disabled}
      className={`
                transition-all outline-none py-[12px] h-auto
                ${item.disabled && 'disabled'}
                w-full text-text-md text-gray-900 rounded-md border border-gray-300 bg-white
                placeholder:text-gray-400 placeholder:text-text-md
                focus:shadow-focus focus:border-primary-500
                hover:border-primary-500 shadow-xs
                ${sizeType[item.size]}
                ${item.innerClassName || ''}
                ${validationMessage ? 'border-red-500 border-2' : ''}
            `}
      rows={item.rows || '3'}
      onChange={(e) => {
        handleChange(e.target.value, item.name)
      }}
      value={value || ''}
    ></textarea>
  )
}

export default Textarea
